<template>
	<div class="container d-flex justify-content-center">
		<iframe width="90%" height="1400" src="https://datastudio.google.com/embed/reporting/156d1e65-ca3d-4951-bb4e-4a4e0aefdb41/page/1M" frameborder="0" style="border:0" allowfullscreen></iframe>
	</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
